import { handleActions } from 'redux-actions';
import { State, stateUpdate } from './action';

const initialState: State = {
  companyUsers: [],
  frontlineUsers: [],
  servicers: [],
  serverErrors: {},
  isSuccess: false,
};

export default handleActions(
  {
    [String(stateUpdate)]: (state, { payload }) => {
      return {
        ...state,
        ...payload,
      };
    },
  },
  initialState,
);
